import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "success-wrapper" }
const _hoisted_2 = { class: "success-container" }
const _hoisted_3 = { class: "success-icon" }
const _hoisted_4 = { class: "success-title" }
const _hoisted_5 = { class: "success-message" }
const _hoisted_6 = {
  key: 0,
  class: "reservation-info"
}
const _hoisted_7 = { class: "info-item" }
const _hoisted_8 = { class: "info-label" }
const _hoisted_9 = { class: "info-value" }
const _hoisted_10 = { class: "info-item" }
const _hoisted_11 = { class: "info-label" }
const _hoisted_12 = { class: "info-value" }
const _hoisted_13 = { class: "action-buttons" }

import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { SuccessFilled } from '@element-plus/icons-vue'

interface ReservationData {
  reservationId: number
  phone: string
  createTime: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReservationSuccess',
  setup(__props) {

const { t } = useI18n()

const reservationData = ref<ReservationData | null>(null)

onMounted(() => {
  // Get reservation data from URL hash
  const hash = window.location.hash
  const match = hash.match(/#\/success\/(.+)/)
  if (match && match[1]) {
    try {
      reservationData.value = JSON.parse(decodeURIComponent(match[1]))
    } catch (e) {
      console.error('Failed to parse reservation data:', e)
    }
  }
})

const goToMyReservations = () => {
  if (reservationData.value?.phone) {
    window.location.href = `/#/my-reservations?phone=${reservationData.value.phone}`
  }
}

const goToHome = () => {
  window.location.href = '/'
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_icon, {
          size: 80,
          color: "#67c23a"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SuccessFilled))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)('success.title')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('success.message')), 1),
      (reservationData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('success.reservationId')) + ":", 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(reservationData.value.reservationId), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('success.phone')) + ":", 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString(reservationData.value.phone), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: goToMyReservations
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('success.viewMyReservations')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          size: "large",
          onClick: goToHome
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('success.backToHome')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})